import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import styles from "./style.module.css";
import CustomCarousel from "../../../../common/Carousel/index";
const HTLPTips = ({ tips, product }) => {
    const dotsStyles = {
        display: "flex",
        justifyContent: "center",
        background: "#ffffff",
        opacity: "0.2",
    };
    const dotsWrapperStyles = {
        display: "flex",
        justifyContent: "center",
        background: "transparent",
        bottom: "-35px",
    };
    return (_jsxs(_Fragment, { children: [_jsx("div", { className: styles.tips_margin_container_mob, children: _jsxs("div", { className: styles.tips_container, children: [_jsx("h1", { className: styles.tips_title, children: `${product} tips for you` }), _jsx(CustomCarousel, { className: styles.tip_carousel, minimumSlides: tips.length, extraSettings: {
                                slidesToShow: 1,
                                arrows: false,
                            }, white: true, dotsStyles: dotsStyles, dotsWrapperStyles: dotsWrapperStyles, children: tips.map((tip) => (_jsx("div", { className: styles.tip_str_container, children: _jsx("p", { className: styles.tip_str, children: tip }) }, tip))) })] }) }), _jsx("div", { className: styles.tips_desktop_container, children: _jsxs("div", { className: styles.tips_container, children: [_jsx("h1", { className: styles.tips_title, children: `${product} tips for you` }), _jsx(CustomCarousel, { className: styles.tip_carousel, arrowsOnSides: tips.length > 1, minimumSlides: tips.length, extraSettings: {
                                slidesToShow: 1,
                                arrows: false,
                            }, white: true, dotsStyles: dotsStyles, dotsWrapperStyles: dotsWrapperStyles, children: tips.map((tip) => (_jsx("div", { className: styles.tip_str_container, children: _jsx("p", { className: styles.tip_str, children: tip }) }, tip))) })] }) })] }));
};
export default HTLPTips;
